import { Helpers } from '../../helpers';
import { ICellarDesign } from '../../interfaces/icellar-design';
import { Pad } from '../pad';

export class CellarDesignBase {
  CellarDesignId: number;
  Description: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Pads_CellarDesign?: Array<Pad> | null;

  constructor(item?: ICellarDesign) {
    if (item) {

      this.CellarDesignId = item.CellarDesignId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Pads_CellarDesign = Helpers.createClassArray(Pad, item.Pads_CellarDesign);
    }
  }
}